import React from 'react';
import { invertColor } from 'src/utils/helpers';
import { StyledTag } from './styles';

const SelectedTag = ({ label, value, closable, onClose }) => {
  const color = JSON.parse(value).color;

  const onPreventMouseDown = (event) => {
    event.preventDefault();
    event.stopPropagation();
  };

  return (
    <StyledTag
      textColor={invertColor(color, true)}
      color={color}
      onMouseDown={onPreventMouseDown}
      closable={closable}
      onClose={onClose}
      style={{
        marginRight: 3,
      }}
    >
      {label}
    </StyledTag>
  )
}

export default SelectedTag;